(function () {
  'use strict';

  angular.module('ringbaPortal').directive('customAutofocus', customAutofocus);

  function customAutofocus(
    $timeout
  ) {
    'ngInject';

    const directive = {
      restrict: 'A',
      link: link
    };
    return directive;

    function link(scope, element, attrs) {
      scope.$watch(attrs.customAutofocus, function (val) {
        if (angular.isDefined(val) && val) {
          $timeout(function () { 
            element.focus(); 
          });
        }
      }, true);
    }
  }

})();
